import { render, staticRenderFns } from "./ViewContactsCO.vue?vue&type=template&id=53978514&scoped=true"
import script from "./ViewContactsCO.vue?vue&type=script&lang=js"
export * from "./ViewContactsCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53978514",
  null
  
)

export default component.exports